import config from "@/config";
import { requests } from ".";

const EMAIL_SERVER_URL = config?.EMAIL_SERVER_URL;

interface EMAIL_LIST_PARAMS {
  locationId: string;
}
interface CREATE_CAMPAIGN {
  locationId: string;
  templateId: string;
  formId: string;
}

export const EmailService = {
  getEmailList: (params: EMAIL_LIST_PARAMS) =>
    requests(EMAIL_SERVER_URL).get("/emails/builder/all", {
      params: {
        locationId: params.locationId,
        type: "builder",
        deleted: false,
      },
    }),
  createCampaign: (params: CREATE_CAMPAIGN) =>
    requests(EMAIL_SERVER_URL).post(`emails/schedule/insert-form/${params.locationId}`, {
      templateId: params.templateId,
      formId: params.formId,
    }),
};
